import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import services from '../../services'
import '../../novo/gestao/gestao.scss'

interface Link { url: string; nomeDoArquivo: string; expiraEm: string }

const dataHora = (iso: string) => new Date(iso).toLocaleDateString('pt-BR')

/**
 * Página do link do book de fotos que chega por e-mail. Quem entra já está logado (ou passou pelo login e voltou para cá); o servidor
 * confere se o book é dele e devolve um link curto do arquivo, que o navegador baixa.
 */
export default function BookDownload() {
  const { id } = useParams()
  const [link, setLink] = useState<Link | null>(null)
  const [erro, setErro] = useState<string | null>(null)

  const pedir = useCallback(async () => {
    setErro(null)
    const r: any = await services.api.bookLink(Number(id))
    if (r.fail) { setErro(r.error || 'Não foi possível abrir este book.'); return }
    setLink(r.data)
    window.location.href = r.data.url
  }, [id])

  useEffect(() => { pedir() }, [pedir])

  return (
    <div className="ng">
      <div className="ng-cartao" style={{ maxWidth: 560, margin: '48px auto' }}>
        <div className="ng-cartao-cab"><h2>Book de fotos</h2></div>
        {!link && !erro && <p className="ng-explic">Preparando o download…</p>}
        {erro && (
          <>
            <p className="ng-explic" role="alert">{erro}</p>
            <div className="ng-acoes"><button type="button" className="ng-btn" onClick={pedir}>Tentar de novo</button></div>
          </>
        )}
        {link && (
          <>
            <p className="ng-explic">O download de <b>{link.nomeDoArquivo}</b> começou. Se não começou, use o botão abaixo.</p>
            <p className="ng-explic">Este book fica disponível até {dataHora(link.expiraEm)}.</p>
            <div className="ng-acoes"><a className="ng-btn prim" href={link.url}>Baixar de novo</a></div>
          </>
        )}
      </div>
    </div>
  )
}
